import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fmt = (n) => `${Number(n).toFixed(2).replace(".", ",")} €`;
export const imgW = (u, w = 700) => {
  if (!u || u.includes("?")) return u;
  if (u.startsWith("/api/files/")) return `${u}?w=${w}`;
  const m = u.match(/^\/home\/([\w-]+?)(?:-(?:800|1600)\.webp|\.jpg)$/);
  return m ? `/static/home/${m[1]}-${w <= 800 ? 800 : 1600}.webp` : u;
};
export const parseNum = (v) => { const n = parseFloat(String(v ?? "").replace(",", ".")); return isNaN(n) ? 0 : n; };
export const TYPE_PATH = { cookie: "/cookies", brownie: "/brownies", cupcookie: "/cupcookies", prepared_box: "/box", box: "/box" };
export const productUrl = (p) => `${TYPE_PATH[p?.type] || (p?.type ? `/${p.type}` : "/cookies")}/${p?.slug || p?.id}`;

export const ORDER_STATUS_LABELS = {
  pending: "En attente",
  confirmed: "Confirmée",
  preparing: "En préparation",
  baking: "En cuisson",
  ready: "Prête",
  shipped: "Expédiée",
  delivered: "Livrée",
  picked_up: "Retirée",
  completed: "Terminée",
  cancelled: "Annulée",
};

export const PAYMENT_STATUS_LABELS = {
  pending: "En attente",
  paid: "Payée",
  refunded: "Remboursée",
  on_site: "À payer sur place",
};

export const ORDER_MODE_LABELS = {
  pickup: "Retrait",
  delivery: "Livraison",
  shipping: "Expédition",
  local: "Livraison locale",
  chronopost: "Chronopost",
};

export const RECEPTION_MODE_OPTIONS = [
  { key: "pickup", label: "Retrait à Palaiseau" },
  { key: "local", label: "Livraison locale" },
  { key: "delivery", label: "Mondial Relay" },
  { key: "shipping", label: "Colissimo" },
  { key: "chronopost", label: "Chronopost" },
];

export default api;
